import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import qs from 'qs'

import Auth from './Auth'
import * as fromAuth from '@src/redux/modules/auth'

const mapStateToProps = (state, ownProps) => {
  const loggedIn = fromAuth.isLoggedIn(state)
  const authenticating = fromAuth.isAuthenticating(state)
  const {
    route: { type },
    location: { search }
  } = ownProps

  const queryString = search.slice(1)
  const { next } = qs.parse(queryString)

  return {
    loggedIn,
    authenticating,
    type,
    next
  }
}

const mapDispatchToProps = {
  signup: fromAuth.signup,
  login: fromAuth.login,
  fbLogin: fromAuth.fbLogin,
  replace
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Auth)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Auth/AuthContainer.js